/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { opexesProductsCopyCreate } from '../fn/opexs-products/opexes-products-copy-create';
import { OpexesProductsCopyCreate$Params } from '../fn/opexs-products/opexes-products-copy-create';
import { opexesProductsCreate } from '../fn/opexs-products/opexes-products-create';
import { opexesProductsCreate$FormData } from '../fn/opexs-products/opexes-products-create-form-data';
import { OpexesProductsCreate$FormData$Params } from '../fn/opexs-products/opexes-products-create-form-data';
import { OpexesProductsCreate$Params } from '../fn/opexs-products/opexes-products-create';
import { opexesProductsCreate$XWwwFormUrlencoded } from '../fn/opexs-products/opexes-products-create-x-www-form-urlencoded';
import { OpexesProductsCreate$XWwwFormUrlencoded$Params } from '../fn/opexs-products/opexes-products-create-x-www-form-urlencoded';
import { opexesProductsDestroy } from '../fn/opexs-products/opexes-products-destroy';
import { OpexesProductsDestroy$Params } from '../fn/opexs-products/opexes-products-destroy';
import { opexesProductsEnumsRetrieve } from '../fn/opexs-products/opexes-products-enums-retrieve';
import { OpexesProductsEnumsRetrieve$Params } from '../fn/opexs-products/opexes-products-enums-retrieve';
import { opexesProductsList } from '../fn/opexs-products/opexes-products-list';
import { OpexesProductsList$Params } from '../fn/opexs-products/opexes-products-list';
import { opexesProductsPartialUpdate } from '../fn/opexs-products/opexes-products-partial-update';
import { opexesProductsPartialUpdate$FormData } from '../fn/opexs-products/opexes-products-partial-update-form-data';
import { OpexesProductsPartialUpdate$FormData$Params } from '../fn/opexs-products/opexes-products-partial-update-form-data';
import { OpexesProductsPartialUpdate$Params } from '../fn/opexs-products/opexes-products-partial-update';
import { opexesProductsPartialUpdate$XWwwFormUrlencoded } from '../fn/opexs-products/opexes-products-partial-update-x-www-form-urlencoded';
import { OpexesProductsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-products/opexes-products-partial-update-x-www-form-urlencoded';
import { opexesProductsRetrieve } from '../fn/opexs-products/opexes-products-retrieve';
import { OpexesProductsRetrieve$Params } from '../fn/opexs-products/opexes-products-retrieve';
import { opexesProductsUpdate } from '../fn/opexs-products/opexes-products-update';
import { opexesProductsUpdate$FormData } from '../fn/opexs-products/opexes-products-update-form-data';
import { OpexesProductsUpdate$FormData$Params } from '../fn/opexs-products/opexes-products-update-form-data';
import { OpexesProductsUpdate$Params } from '../fn/opexs-products/opexes-products-update';
import { opexesProductsUpdate$XWwwFormUrlencoded } from '../fn/opexs-products/opexes-products-update-x-www-form-urlencoded';
import { OpexesProductsUpdate$XWwwFormUrlencoded$Params } from '../fn/opexs-products/opexes-products-update-x-www-form-urlencoded';
import { BackendProductDto } from '../models/backend-product-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiOpexsProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `opexesProductsList()` */
  static readonly OpexesProductsListPath = '/api/opexes/products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsList$Response(
    params?: OpexesProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendProductDto>>> {
    return opexesProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsList(params?: OpexesProductsList$Params, context?: HttpContext): Observable<Array<BackendProductDto>> {
    return this.opexesProductsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendProductDto>>): Array<BackendProductDto> => r.body),
    );
  }

  /** Path part for operation `opexesProductsCreate()` */
  static readonly OpexesProductsCreatePath = '/api/opexes/products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsCreate$Response(
    params: OpexesProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsCreate(params: OpexesProductsCreate$Params, context?: HttpContext): Observable<BackendProductDto> {
    return this.opexesProductsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsCreate$XWwwFormUrlencoded$Response(
    params: OpexesProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsCreate$XWwwFormUrlencoded(
    params: OpexesProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsCreate$FormData$Response(
    params: OpexesProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsCreate$FormData(
    params: OpexesProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /** Path part for operation `opexesProductsRetrieve()` */
  static readonly OpexesProductsRetrievePath = '/api/opexes/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsRetrieve$Response(
    params: OpexesProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsRetrieve(params: OpexesProductsRetrieve$Params, context?: HttpContext): Observable<BackendProductDto> {
    return this.opexesProductsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /** Path part for operation `opexesProductsUpdate()` */
  static readonly OpexesProductsUpdatePath = '/api/opexes/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsUpdate$Response(
    params: OpexesProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsUpdate(params: OpexesProductsUpdate$Params, context?: HttpContext): Observable<BackendProductDto> {
    return this.opexesProductsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsUpdate$XWwwFormUrlencoded$Response(
    params: OpexesProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsUpdate$XWwwFormUrlencoded(
    params: OpexesProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsUpdate$FormData$Response(
    params: OpexesProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsUpdate$FormData(
    params: OpexesProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /** Path part for operation `opexesProductsDestroy()` */
  static readonly OpexesProductsDestroyPath = '/api/opexes/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsDestroy$Response(
    params: OpexesProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsDestroy(params: OpexesProductsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.opexesProductsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `opexesProductsPartialUpdate()` */
  static readonly OpexesProductsPartialUpdatePath = '/api/opexes/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsPartialUpdate$Response(
    params: OpexesProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  opexesProductsPartialUpdate(
    params: OpexesProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsPartialUpdate$XWwwFormUrlencoded$Response(
    params: OpexesProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  opexesProductsPartialUpdate$XWwwFormUrlencoded(
    params: OpexesProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsPartialUpdate$FormData$Response(
    params: OpexesProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  opexesProductsPartialUpdate$FormData(
    params: OpexesProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /** Path part for operation `opexesProductsCopyCreate()` */
  static readonly OpexesProductsCopyCreatePath = '/api/opexes/products/{id}/copy/';

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsCopyCreate$Response(
    params: OpexesProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendProductDto>> {
    return opexesProductsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Базовый класс для копирования объектов opexes (COSTS section).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsCopyCreate(
    params: OpexesProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendProductDto> {
    return this.opexesProductsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendProductDto>): BackendProductDto => r.body),
    );
  }

  /** Path part for operation `opexesProductsEnumsRetrieve()` */
  static readonly OpexesProductsEnumsRetrievePath = '/api/opexes/products/enums/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `opexesProductsEnumsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsEnumsRetrieve$Response(
    params: OpexesProductsEnumsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return opexesProductsEnumsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `opexesProductsEnumsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  opexesProductsEnumsRetrieve(params: OpexesProductsEnumsRetrieve$Params, context?: HttpContext): Observable<void> {
    return this.opexesProductsEnumsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }
}
